export default "__VITE_ASSET__1550ec65__"